import { applyMode, Mode } from "@amzn/awsui-global-styles";
import React, {
  createContext,
  PropsWithChildren,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

import { CookieContext, CookieKeys } from "../CookieProvider";

interface DarkModeContextProps {
  enabled: boolean;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DarkModeContext = createContext<DarkModeContextProps>(
  {} as DarkModeContextProps
);

const DarkModeProvider = (props: PropsWithChildren<ReactNode>) => {
  const cookies = useContext(CookieContext);
  const [enabled, setEnabled] = useState<boolean>(
    cookies.get(CookieKeys.darkMode) === "true"
  );

  useEffect(() => {
    applyMode(enabled ? Mode.Dark : Mode.Light);
    cookies.set(CookieKeys.darkMode, String(enabled), { path: "/" });
  }, [enabled]);

  return (
    <DarkModeContext.Provider value={{ enabled, setEnabled }}>
      {props.children}
    </DarkModeContext.Provider>
  );
};

export default DarkModeProvider;
